const D_P = 'master';
const D_B = 'beta';
const D_T = 'test';
const D_Q = 'qa';
const D_S = 'staging';
const D_D = 'development';

export const DEPLOYMENT = Object.freeze({
  // synonyms for prod
  production: D_P,
  prod: D_P,

  // alpha doesn't get static moniker
  beta: D_B,

  // synonyms for staging
  staging: D_S,
  stage: D_S,

  // synonyms for quality assurance
  qa: D_Q,

  // synonyms for testing
  testing: D_T,
  test: D_T,

  // synonyms for development
  development: D_D,
  dev: D_D,
  local: D_D,
});

export const NODE = Object.freeze({
  test: 'test',
  dev: 'development',
  prod: 'production',
});

export const REACT = Object.freeze({
  stage: 'staging',
  qa: 'qa',
  alpha: 'alpha',
  beta: 'beta',
});

export const V = Object.freeze({
  d: 'dev',
  t: 'test',
  q: 'qa',
  p: 'prod',
  s: 'prod-stage',
  b: 'prod-alpha-beta',
  m: 'prod-master',
});
